export const TableDataRowProp = Object.freeze({
    Cells: 'cells',
    Color: 'color',
    RowKey: 'rowKey',
    RowNumber: 'rowNumber',
});
